import { FileText, CheckCircle } from 'lucide-react';
import { useEffect } from 'react';

export const TypeformEmbed = () => {
  useEffect(() => {
    // Load Typeform script
    const script = document.createElement('script');
    script.src = '//embed.typeform.com/next/embed.js';
    script.async = true;
    document.body.appendChild(script);

    return () => {
      // Cleanup
      const existingScript = document.querySelector('script[src="//embed.typeform.com/next/embed.js"]');
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <section id="typeform-section" className="py-12 md:py-16 bg-navy-light" data-testid="typeform-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 bg-gold/10 border border-gold/30 rounded-full px-4 py-2 mb-4">
            <FileText className="w-4 h-4 text-gold" />
            <span className="text-gold text-sm font-medium">Finanční plán na míru</span>
          </div>
          <h2 className="font-serif text-2xl md:text-3xl font-bold text-white mb-4">
            Získejte personalizovaný finanční plán
          </h2>
          <p className="text-gray-400 max-w-xl mx-auto">
            Vyplňte krátký dotazník a obdržíte finanční plán přizpůsobený vaší situaci. Zdarma a bez závazků.
          </p>
        </div>

        {/* Benefits */}
        <div className="flex flex-wrap justify-center gap-4 mb-8">
          {['Analýza financí', 'Investiční strategie', 'Doporučení na míru'].map((benefit) => (
            <div key={benefit} className="flex items-center gap-2 text-gray-300 text-sm">
              <CheckCircle className="w-4 h-4 text-green" />
              {benefit}
            </div>
          ))}
        </div>

        {/* Typeform Embed */}
        <div className="rounded-2xl overflow-hidden border border-white/10 bg-white min-h-[600px]">
          <div data-tf-live="01KFGR01CXSDNY5RB1GJWJK83T" style={{ width: '100%', height: '600px' }}></div>
        </div>
      </div>
    </section>
  );
};
